export default "assets/images/logo-33f63304.svg";